import React, { useEffect, useState } from "react";
import LayoutFrontend from "./inc/layout-frontend";
import { Link, useNavigate, useParams } from "react-router-dom";
import { myroutes } from "../routes/webroute";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form';
import { Image } from "react-bootstrap";
import EditeursService from "../services/EditeursService";
import AuteursService from "../services/AuteursService";
import PublicationsService from "../services/PublicationsService";
import PeriodiquesService from "../services/PeriodiquesService";
import { app_url } from "../services/http";
import CategoriesService from "../services/CategoriesService";
import { addToCart } from "../app/providers/panierSlice";
import { useDispatch, useSelector } from "react-redux";





export default function DetailsPublications() {

    const { id } = useParams();

    const [publications, setPublications] = useState([]);

    const [publication, setPublication] = useState(null);
    

    const [editeurs, setEditeurs] = useState([]);

    const [periodiques, setPeriodiques] = useState([]);

    const [categories, setCategories] = useState([]);

    const [auteurs, setAuteurs] = useState([]);

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const {contentPanier} = useSelector(state => state.panier)

    

      // Récupérer les editeurs depuis la base de données
        useEffect(() => {
          const fetchEditeurs = async () => {
            try {
              const response = await EditeursService.index();
              const data = response.data.liste_editeurs;
              const editeursArray = Array.isArray(data) ? data : Object.values(data);
              setEditeurs(editeursArray);
            } catch (error) {
              console.log(error);
            }
          };
          fetchEditeurs();
        }, []);

        useEffect(() => {
          AuteursService.index()
            .then(response => {
              if (Array.isArray(response.data.liste_auteurs)) {
                setAuteurs(response.data.liste_auteurs);
              } else {
                console.error('La réponse ne contient pas un tableau auteurs:', response.data);
              }
            })
            .catch(error => {
              console.error('Erreur lors de la récupération des auteurs:', error);
            });
        
          }, []);  

          useEffect(() => {
            const fetchCategories = async () => {
              try {
                const response = await CategoriesService.index();
                const data = response.data.categories;
                const categoriesArray = Array.isArray(data) ? data : Object.values(data);
                setCategories(categoriesArray);
               // console.log(categoriesArray)

              } catch (error) {
                console.log(error);
              }
            };
            fetchCategories();
          }, []);
        

         
          useEffect(() => {
            const fetchPublication = async () => {
              try {
                const response = await PublicationsService.getPublication(id);
                const data = response.data; // Modifier en fonction de la structure de votre réponse
                setPublication(data);
              } catch (error) {
                console.error('Erreur lors de la récupération de la publication:', error);
              }
            };
          
            fetchPublication();
          }, [id]);
          
          useEffect(() => {
            const fetchPublications = async () => {
                try {
                  const response = await PublicationsService.index();
                  setPublications(response.data.publications); // Utilisez response.data.publications au lieu de response.data
                  // Récupérer les libellés des périodiques à partir des IDs
                  const ids = response.data.publications.map(publication => publication.periodique_id);
                  const periodiquesResponse = await PeriodiquesService.index(ids);
                  setPeriodiques(periodiquesResponse.data.liste_periodiques);    
                } catch (error) {
                  console.log(error);
                }
              };
              
            fetchPublications();
          }, []);

          

          const ajouterPanier = async (publication) => {
            try {
              let price = publication.montant_publication; // Valeur par défaut
          
              if (publication.typepublication_id === 2 && publication.periodique_id) {
                // Récupérer les informations du périodique
                const periodique = periodiques.find((periodique) => periodique.id === publication.periodique_id);
          
                if (periodique) {
                  price = periodique.montant_periodique; // Utiliser montant_periodique pour typepublication_id = 2
                }
              }
          
              let set_publication = {
                id: publication.id,
                name: publication.titre,
                price: price,
                laune: publication.laune_path,
              };
              let item = { ...set_publication, quantity: 1 };
              dispatch(addToCart(item));
              // Voir le contenu du panier
              console.log(contentPanier);
            } catch (error) {
              console.log(error);
            }
          };
          

    return (
    <LayoutFrontend>   
          {/** Navbar Start */}
    <div className="container-fluid position-relative p-0">
    
                <div className="container-fluid bg-primary py-5 bg-header" style={{ marginBottom:"90px" }}>
            <div className="row py-5">
                <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                    <h1 className="display-4 text-white animated zoomIn">Details</h1>
                    <Link className="h5"  style={{ color:"goldenrod"}} to={myroutes.catalogue}>
                    Catalogue
                    </Link>
                    <i className="far fa-circle text-white px-2"></i>
                    <Link className="h5 text-white" to={myroutes.comment_ca_marche}>
                    Details Publications
                    </Link>
                </div>
            </div>
        </div>
       
    </div>

<Container>
<Row>
      <Col xs={12} md={3} style={{ paddingLeft: '20px', minHeight: "100px" }}>
        {/* Colonne de l'image */}
        {publication && <Image alt="Image" style={{ width: '100%', height: 'auto', border: '1px solid gold' }} src={app_url + "/storage/laune/" + publication.laune_path} />}
      </Col>

      <Col xs={12} md={1}></Col>

      <Col xs={12} md={8} style={{ backgroundColor: 'whitesmoke', padding: '40px', borderRadius: '5px', boxShadow: '3px 3px rgb(207, 225, 251)' }}>
        {/* Colonne des informations de la publication */}
        <div className="">
          {publication && publication.typepublication_id === 2 ? (
            <>
              <h2 className="" style={{ fontWeight: 'bold', color: "#116BB9", lineHeight: "3rem", fontSize: '30px', backgroundColor:"none" }}>{publication.titre_periodique}</h2>
            </>
          ) : (
            <h2 className="" style={{ fontWeight: 'bold', color: "#116BB9", lineHeight: "3rem", fontSize: '30px' }}>{publication && publication.titre_concatene}</h2>
          )}
        </div>
        <div className="text-center py-2" style={{ color: "black", fontWeight: "bold"}}>
          {publication && publication.typepublication_id === 2 && Array.isArray(periodiques) ? (
            // Informations spécifiques aux périodiques
            <Button className="mt-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "200px", fontWeight: "900", fontSize: "18px" }} variant="warning">
              {periodiques.find((periodique) => periodique.id === publication.periodique_id)?.montant_periodique?.toLocaleString() || 'N/A'}{' '}
              F CFA
            </Button>
          ) : (
            // Informations générales des publications
            <Button className="mt-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "200px", fontWeight: "900", fontSize: "18px" }} variant="warning">
              {publication && publication.montant_publication?.toLocaleString()} F CFA
            </Button>
          )}
        </div> <br />

       {/** <h2 className="" style={{ fontWeight: 'bold', color: "#116BB9", lineHeight: "3rem", fontSize: '30px' }}>{publication && publication.titre}</h2>
        <Button className="mt-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "200px", fontWeight: "900", fontSize: "18px" }} variant="warning">{publication && publication.montant_publication} FCFA</Button>  <br /> */}

        <p className="mb-4" style={{ color: 'black', fontSize: '24px' }}>Editeurs: <span style={{ color: 'black', fontSize: '24px', fontWeight: "800" }}>{publication && editeurs.find((editeur) => editeur.id === publication.editeur_id)?.raison_sociale}</span> </p>

        <p className="mb-4" style={{ color: 'black', fontSize: '24px' }}>Auteurs: <span style={{ color: 'black', fontSize: '24px', fontWeight: "800" }}>{publication && auteurs.find((auteur) => auteur.id === publication.auteur_id)?.nom_auteur}</span></p>

        <p className="mb-4 mt-3" style={{ color: 'black', fontSize: '24px' }}> Année: <span style={{ color: 'black', fontSize: '24px', fontWeight: "800" }}> {publication && publication.annee_publication}</span></p>

        <p>{publication && publication.description}</p>

        <Link className="btn btn-primary mt-2 me-3" onClick={()=>ajouterPanier(publication)}> <i className="fas fa-shopping-cart me-2"></i>Ajouter au Panier </Link>

        <Button variant="outline-warning mt-2 me-3"><i className="fas fa-heart me-2"></i></Button>{' '}
        {/* ... */}
      </Col>
    </Row>
</Container>

<Container  style={{marginBottom:"80px"}}>
  <Row>
    <div className="tab-content mt-5">
    {publication && publication.typepublication_id === 2?(
       <>
      {/** Si la publication est une périodique on affiche un menu d'abonnement sinon non */}
    <Tabs
      defaultActiveKey="resume"
      id="fill-tab-example"
      className="head-tab mb-3 mt-5"
      fill
    >
      <Tab eventKey="resume" title="Résumé" className="title-tab" style={{textAlign:"justify"}}>
      {publication && publication.resume}    
      </Tab>
      <Tab eventKey="caracteristiques" title="Caractéristiques" className="title-tab">
        <table className="table-characteristics">
          <tbody>
            <tr>
              <th>ISBN</th>
              <td>{publication && publication.code_isbn}</td>
            </tr>
            <tr>
              <th>Titre</th>
              <td>{publication && publication.titre}</td>
            </tr>
            <tr>
              <th>Sous-titre</th>
              <td>{publication && publication.sous_titre}</td>
            </tr>
            <tr>
              <th>Date publication</th>
              <td>{publication && publication.annee_publication}</td>
            </tr>
            <tr>
              <th>Nombre de pages</th>
              <td>{publication && publication.nbre_page} pages</td>
            </tr>
            <tr>
              <th>Auteur</th>
              <td>{publication && auteurs.find((auteur) => auteur.id === publication.auteur_id)?.nom_auteur}</td>
            </tr>
            <tr>
              <th>Editeur</th>
              <td>{publication && editeurs.find((editeur) => editeur.id === publication.editeur_id)?.raison_sociale}</td>
            </tr>
            <tr>
              <th>Catégorie</th>
              <td>{publication && categories.find((categorie) => categorie.id === publication.categorie_id)?.libelle}</td>
            </tr>
            <tr>

            </tr>
          </tbody>
        </table>
      </Tab>

      <Tab eventKey="abonnement" title="Abonnement" className="title-tab">
        <p style={{fontStyle:"italic", fontSize:"19px", textAlign:'center', color:"black", }}>Merci de bien vouloir renseignez ce formulaire pour vous abonner à cette publication 
      </p>
      <h2 className="" style={{ fontWeight: 'bold', color:"#116BB9", lineHeight:"3rem", fontSize:'26px', textAlign:'center', marginTop:"30px" }}>{publications.titre}</h2>

      <div className="col-lg-8 mx-auto mt-4 mb-5" >
      <Form>
        <Form.Label>Durée d'abonnement <i  style={{color:"red"}}>*</i> </Form.Label>
        <Form.Select aria-label="Default select example" className="mb-3">
      <option>Choisir une durée</option>
      <option value="1">Aucune valeur disponible</option>
    </Form.Select>
    <Form.Label>Prix d'abonnement (FCFA)<i  style={{color:"red"}}>*</i>  </Form.Label>
      <Form.Control
        type="text"
        placeholder="1900"
        aria-label="Disabled input example"
        readOnly
      />
      <Button variant="primary" className="mt-4 lg mx-auto">S'abonner</Button>{' '}
    </Form>

</div>
      </Tab>

    </Tabs>
           </>
       ) : (
  <Tabs
      defaultActiveKey="resume"
      id="fill-tab-example"
      className="head-tab mb-3 mt-5"
      fill
     
    >
      <Tab eventKey="resume" title="Résumé" className="title-tab" style={{textAlign:"justify"}}>
      {publication && publication.resume}    
      </Tab>
      <Tab eventKey="caracteristiques" title="Caractéristiques" className="title-tab">
        <table className="table-characteristics">
          <tbody>
            <tr>
              <th>ISBN</th>
              <td>{publication && publication.code_isbn}</td>
            </tr>
            <tr>
              <th>Titre</th>
              <td>{publication && publication.titre}</td>
            </tr>
            <tr>
              <th>Sous-titre</th>
              <td>{publication && publication.sous_titre}</td>
            </tr>
            <tr>
              <th>Date publication</th>
              <td>{publication && publication.annee_publication}</td>
            </tr>
            <tr>
              <th>Nombre de pages</th>
              <td>{publication && publication.nbre_page} pages</td>
            </tr>
            <tr>
              <th>Auteur</th>
              <td>{publication && auteurs.find((auteur) => auteur.id === publication.auteur_id)?.nom_auteur}</td>
            </tr>
            <tr>
              <th>Editeur</th>
              <td>{publication && editeurs.find((editeur) => editeur.id === publication.editeur_id)?.raison_sociale}</td>
            </tr>
            <tr>
              <th>Catégorie</th>
              <td>{publication && categories.find((categorie) => categorie.id === publication.categorie_id)?.libelle}</td>
            </tr>
            <tr>

            </tr>
          </tbody>
        </table>
      </Tab>
    </Tabs>    
      )}
  
    </div>
  </Row>
</Container>

<div className="divider">
  <hr className="top-line" />
  <Button variant="primary" className="middle-text" style={{width:"300px", fontSize:"20px"}}>Vous pouvez voir aussi...</Button>
  <hr className="bottom-line" />
</div>

 {/* Documents Start */}
 <div className="container-fluid py-3 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container py-3">
                <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" >
                    <h5 className="fw-bold text-primary text-uppercase"></h5>
                    <h1 className="text-legend mb-3 ">OUVRAGES ET PERIODIQUES EN VENTE</h1>
                </div>
                    <div className="row g-5 mt-0">
                    {publications.slice(0,4).map((publication, index) => (
                    <div key={index} className="col-lg-3 wow slideInUp" data-wow-delay="0.3s">
                        <div className="team-item bg-light rounded overflow-hidden">
                        <div className="team-img position-relative overflow-hidden">
                            <Image className="img-fluid w-100" alt="image indisponible" style={{height:"380px"}} src={app_url + "/storage/laune/" + publication.laune_path} />
                            <div className="team-social">
                            <a className="btn btn-lg btn-primary btn-lg-square rounded" href="" onClick={()=>ajouterPanier(publication)}>
                                <i className="fas fa-shopping-cart"></i>
                            </a>
                            <a className="btn btn-lg btn-primary btn-lg-square rounded" href="">
                                <i className="fa fa-heart"></i>
                            </a>
                            <a className="btn btn-lg btn-primary btn-lg-square rounded" href={`/details_publications/${publication.id}`} title="Voir plus d'informations">
                                <i className="fa fa-eye"></i>
                            </a>
                            <a className="btn btn-lg btn-primary btn-lg-square rounded" href="">
                                <i className="fa fa-random"></i>
                            </a>
                            </div>
                        </div>
                        <div className="text-card">
                            {publication.typepublication_id === 2?(
                                <>
                                <p className="text-books" style={{ lineHeight: "1.5rem" }}>{publication.titre_periodique.substring(0, 25)}...</p>
                                </>
                            ) : (
                                <p className="text-books" style={{ lineHeight: "1.5rem" }}>{publication.titre_concatene.substring(0, 25)}...</p>
                            )}
                        </div>
                            <div className="text-center py-2" style={{ color: "black", fontWeight: "bold" , backgroundColor:"rgb(237, 245, 251)"}}>
                            {publication.typepublication_id === 2 && Array.isArray(periodiques) ? (
                                // Informations spécifiques aux périodiques
                                <p className="text-uppercase m-0">      {periodiques.find(p => p.id === publication.periodique_id)?.montant_periodique?.toLocaleString()} F CFA
                                </p>
                            ) : (
                                // Informations générales des publications
                                <p className="text-uppercase m-0">{publication.montant_publication?.toLocaleString()} F CFA</p>
                            )}
                            </div>
                        </div>
                    </div>
                    ))}

                    <div>
                    
                    </div>
                    </div>
                </div>
  </div>
            
            {/* Documents End */}
</LayoutFrontend>
   
   )
}